import { ConfiguratorUIElementStates, ContainerStateBase } from './ElementState';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

let nextId = 0;

export class ContainerState<T extends IUiCfgContainer = IUiCfgContainer> extends ContainerStateBase {
  public id = 'container-view-state-' + ++nextId;
  declare viewElement: T;

  get elementType(): string {
    return this.viewElement.type;
  }

  constructor(children: Array<ConfiguratorUIElementStates>, viewElement: T) {
    super(children, viewElement);
  }
}
